<div ngModelGroup="bankAccountDTO">
  <div class="d-flex flex-column gap-3">
    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityBankAccountDto.bankName"
                   class="w-100"
                   formInlineError
                   id="bankName"
                   name="bankName"
                   bsInputText
                   required
                   type="text" data-testid="bank-name-input">
            <label for="bankName">{{'platform-administration.company.legal-entity.inputs.bankAccount.bankName' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityBankAccountDto.currencyCode"
                   class="w-100"
                   formInlineError
                   id="city"
                   name="currencyCode"
                   bsInputText
                   required
                   type="text" data-testid="city-input">
            <label for="city">{{'platform-administration.company.legal-entity.inputs.bankAccount.currencyCode' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="d-flex flex-column gap-3">
      <div class="row">
        <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityBankAccountDto.iban"
                   class="w-100"
                   formInlineError
                   id="state"
                   name="state"
                   bsInputText
                   required
                   type="text" data-testid="state-input">
            <label for="state">{{'platform-administration.company.legal-entity.inputs.bankAccount.iban' | translate}} *</label>
          </p-floatlabel>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityBankAccountDto.swiftCode"
                   class="w-100"
                   formInlineError
                   id="country"
                   name="country"
                   bsInputText
                   type="text" data-testid="country-input">
            <label for="country">{{'platform-administration.company.legal-entity.inputs.bankAccount.swiftCode' | translate}}</label>
          </p-floatlabel>
      </div>
    </div>
  </div>

</div>


